import React from 'react';
import { Link } from 'react-router-dom';

import { getEnv } from '../../../../lib/utils/getEnv';

const { VITE_HELP_CENTRE_URL } = getEnv();

export const faqsConfig = [
  {
    question: 'What makes Pata the right booking software for canine hydrotherapists?',
    answer: () => (
      <>
        <p>
          Pata is built with canine hydrotherapists and other pet care professionals in mind. Designed with easy-to-use
          features, our platform helps you take online bookings, view medical history at a glance, and minimise
          no-shows.  
        </p>

        <p>
          Whether you work solo or manage multiple hydrotherapy locations, you get full access to an intuitive booking
          platform that streamlines your business and makes appointments easy — all without monthly fees.
        </p>
      </>
    ),
  },
  {
    question: 'Can clients book sessions online?',
    answer: () => (
      <>
        <p>
          Yes, if you want them to. Our booking platform allows you to take therapy bookings online or you can simply
          use the calendar as a digital diary, keeping you in control of your time.
        </p>

        <p>
          If you enable online appointments, customers get 24/7 access to your calendar which means fewer calls for you
          and a seamless booking experience for them. You can also choose whether this feature is limited to existing
          clients only, or available to new customers as well.
        </p>

        <p>No matter how you prefer to take bookings, Pata has flexible features to suit your business needs.</p>
      </>
    ),
  },
  {
    question: 'Can I collect payments in advance?',
    answer: () => (
      <>
        <p>
          Of course! We know <Link to="/business/pata-pay">upfront payments </Link>
          are proven to reduce no-shows and late cancellations, so Pata makes it easy to protect your time and minimise
          frustration for your pet care business.
        </p>

        <p>
          With our booking software, you have the option to set a custom deposit amount or choose to request full
          payments in advance. You can also collect a client’s payment card when they book online, covering you for any
          no-show or late cancellation charges.
        </p>
      </>
    ),
  },

  {
    question: 'Can I manage my client session notes?',
    answer: () => (
      <>
        <p>
          Pata makes it easy to view session notes and medical information in one central, secure platform. With a few
          clicks, you can add notes for specific appointments, clients or pets, and upload pictures or documents to
          their profiles.
        </p>

        <p>
          Notes are date and time stamped, plus ordered from newest to oldest, making it easy to track hydrotherapy
          progress. You can also see who created each note — perfect for clinics with multiple employees.
        </p>
      </>
    ),
  },
  {
    question: 'Do I really need a pet-specific software?',
    answer: () => (
      <>
        <p>
          We might be biased, but yes. We’ve heard from many partners that switching from a generic booking system to
          pet-specific software has been game changing for their business, helping to reduce admin and tackle no-shows.
        </p>

        <p>
          Pata booking platform is tailored to the pet care industry, meaning no workarounds for listing your dog
          hydrotherapy services or managing detailed medical information.
        </p>

        <p>
          We are also constantly improving our software based on feedback from our pros to ensure we give you and your
          customers the best experience possible.
        </p>
      </>
    ),
  },
  {
    question: 'How can Pata help me grow my canine hydrotherapy business?',
    answer: () => (
      <>
        <p>
          As a partner, you get access to the Pata Marketplace — a one-stop-shop for pet owners looking to book trusted
          hydrotherapists and other professionals in their area.
        </p>

        <p>
          When they search on Pata or Google for local clinics, our Marketplace boosts your online visibility, helping
          pet parents discover your business so your network of loyal customers can grow.
        </p>
      </>
    ),
  },
  {
    question: 'Is Pata really subscription-free?',
    answer: () => (
      <>
        <p>
          It really is! We believe every canine hydrotherapy clinic should have easy access to the{' '}
          <Link to="/business/features">latest tools </Link>
          that simplify day-to-day admin, so our booking software is subscription-free.
        </p>

        <p>
          Being a partner means you get to add unlimited appointment bookings, client and email notifications,
          locations, and team members without any upfront or monthly fees to limit your growth.
        </p>

        <p>
          For those wanting to take that extra step, we also offer other features like SMS top-ups and online or
          in-person payments, but they are completely optional.
        </p>
      </>
    ),
  },
  {
    question: 'Can I manage canine hydrotherapy, and other pet care services with Pata?',
    answer: () => (
      <>
        <p>
          Pata booking platform is designed with flexible features that suit all pet care professionals, including those
          who run multiple businesses. This means you can easily manage both hydrotherapy sessions and additional
          services from the same account.
        </p>

        <p>
          Whether you offer dog walking at weekends or boarding overnight, it’s simple to add multiple workplaces with
          individual operating hours, team members and Pata Marketplace profiles.
        </p>

        <p>
          Plus, with our intuitive dashboard and calendar, it only takes a few clicks to switch between workplaces so
          you can schedule your time across multiple businesses and view important information in one place.
        </p>
      </>
    ),
  },
];
